import React from "react";
import { Lock, Check, MessageSquareText, ClipboardList, Video, Crown } from "lucide-react";

// Academy features: locked (padlock) for eBook, unlocked for Academy/Elite.
const FEATURES = [
  { id: "feedback", icon: MessageSquareText, title: "Personal Coach Feedback", desc: "Voice-note breakdowns from Coach Barker on every clip you send.", eliteOnly: false },
  { id: "plan", icon: ClipboardList, title: "Personalized Training Plan", desc: "A custom monthly roadmap built around your goals, position and level.", eliteOnly: true, route: "/roadmap" },
  { id: "oneonone", icon: Video, title: "1-on-1 Video Feedback", desc: "Send any move and get a personal video review back.", eliteOnly: false },
];

const FeatureCard = ({ f, unlocked, onLockedClick, onOpen, isElite }) => {
  const Icon = f.icon;
  if (unlocked) {
    const Wrapper = f.route ? "button" : "div";
    const eliteRoute = f.route && isElite;
    return (
      <Wrapper data-testid={`academy-feature-${f.id}`} onClick={f.route ? onOpen : undefined}
        className={`text-left w-full rounded-xl border p-4 transition-colors ${eliteRoute ? "glass-gold group" : f.route ? "border-[#D4AF37]/40 bg-[#D4AF37]/[0.07] hover:border-[#D4AF37] group" : isElite ? "glass-card border-[#22C55E]/25" : "border-[#22C55E]/30 bg-[#22C55E]/[0.06]"}`}>
        <div className="flex items-center justify-between mb-2">
          <Icon size={18} className="text-white/80" />
          <span className={`flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider ${f.route ? "text-[#D4AF37]" : "text-[#22C55E]"}`}>{f.route ? <><Crown size={12} /> Elite</> : <><Check size={12} /> Included</>}</span>
        </div>
        <div className="font-subheadings font-bold uppercase tracking-wide text-sm">{f.title}</div>
        <p className="text-xs text-white/50 mt-1 leading-relaxed">{f.desc}</p>
        {f.route && <div className="mt-3 text-[11px] font-bold uppercase tracking-wider text-[#D4AF37]/80 group-hover:text-[#D4AF37] transition-colors">Open Roadmap →</div>}
      </Wrapper>
    );
  }
  const gold = f.eliteOnly;
  return (
    <button data-testid={`academy-feature-${f.id}`} onClick={onLockedClick}
      className={`text-left rounded-xl border bg-[#141414] p-4 relative overflow-hidden group transition-colors ${gold ? "border-[#D4AF37]/25 hover:border-[#D4AF37]/50" : "border-white/10 hover:border-[#C41E24]/40"}`}>
      <div className="flex items-center justify-between mb-2">
        <Icon size={18} className="text-white/30" />
        <span data-testid={`academy-lock-${f.id}`} className={`flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider ${gold ? "text-[#D4AF37]" : "text-[#C41E24]"}`}>
          {gold ? <Crown size={12} /> : <Lock size={12} />} {gold ? "Elite Only" : "Locked"}
        </span>
      </div>
      <div className="font-subheadings font-bold uppercase tracking-wide text-sm text-white/70">{f.title}</div>
      <p className="text-xs text-white/40 mt-1 leading-relaxed">{f.desc}</p>
      <div className={`mt-3 text-[11px] font-bold uppercase tracking-wider transition-colors ${gold ? "text-[#D4AF37]/80 group-hover:text-[#D4AF37]" : "text-white/50 group-hover:text-white"}`}>{gold ? "Upgrade to Elite →" : "Unlock →"}</div>
    </button>
  );
};

export default function AcademyFeatures({ isPaid, isElite, onLockedClick, onOpenRoadmap }) {
  return (
    <section data-testid="academy-features" className="mb-10">
      <div className="flex items-center gap-2 mb-4">
        <h2 className="font-subheadings text-sm font-bold uppercase tracking-widest text-white/70">Technical Track Training</h2>
        {!isPaid && <span className="text-[10px] font-bold uppercase tracking-wider text-[#C41E24] bg-[#C41E24]/15 px-2 py-0.5 rounded">Blueprint — Locked</span>}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {FEATURES.map((f) => {
          const unlocked = f.eliteOnly ? isElite : isPaid;
          return <FeatureCard key={f.id} f={f} unlocked={unlocked} isElite={isElite} onLockedClick={() => onLockedClick(f)} onOpen={f.route === "/roadmap" ? onOpenRoadmap : undefined} />;
        })}
      </div>
    </section>
  );
}
